import React from 'react'
import './AboutUs.scss';
import aboutImg1 from '../../../Assets/Images/about-img1.jpg';
import aboutImg2 from '../../../Assets/Images/about-img2.jpg';
import aboutImg3 from '../../../Assets/Images/about-img3.jpg';
import sideFoodImg1 from '../../../Assets/Images/side-food-img1.jpg';
import sideFoodImg2 from '../../../Assets/Images/side-food-img2.jpg';
import sideFoodImg3 from '../../../Assets/Images/side-food-img3.jpg';

export default function AboutUs() {
  return (
    <div>
      <section className='subBanner textCenter'>
          <div className='middle_box'>
            <h1>About Us</h1>
          </div>
      </section>
      <section className='welcome_wrap aboutUs_wrap'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12 textCenter'>
              <div class="titleBox">
						<span>Welcome</span>
						<h2>Otlo The Cafe Restaurant</h2>
              </div>
            </div>
          </div>
			 <div className='contentWrapBox'>
				<div className='row'>				 
					<div className='col-md-6'>
						<p>We believe that a space is defined by other dimensions than its mere physical measurements – like height, width and depth.A well-designed interior expresses your values, views and life philosophy.</p>
					</div>
					<div className='col-md-6'>
						<p className='m-0'>Every project is managed by one of our dedicated project managers and executed in our own workshop. We personally take care of every step in the process; from sketching the very first idea to crafting even the tiniest detail.</p>
					</div>
				</div>
			</div>
        </div>
      </section>
		<section className='sectionPadding gallery_wrap'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-4'>
              <div className='gallery_box responsiveSpace'>
                <a href='#'>
                  <img src={aboutImg1} />
                  <div className='info'>
                    <span className='sub-title'>Dessert / Events / Fish / Meat</span>
                    <h4>Classic CheeseCake</h4>
                    <p>Seasonal Flavours</p>
                  </div>
                  </a>           
              </div>
            </div>
				<div className='col-md-4'>
              <div className='gallery_box responsiveSpace'>
                <a href='#'>
                  <img src={aboutImg2} />
                  <div className='info'>
                    <span className='sub-title'>Dessert / Events / Fish / Meat</span>
                    <h4>Classic CheeseCake</h4>
                    <p>Seasonal Flavours</p>
                  </div>
                  </a>           
              </div>
            </div>
				<div className='col-md-4'>
              <div className='gallery_box'>
                <a href='#'>
                  <img src={aboutImg3} />
                  <div className='info'>
                    <span className='sub-title'>Dessert / Events / Fish / Meat</span>
                    <h4>Classic CheeseCake</h4>
                    <p>Seasonal Flavours</p>
                  </div>
                  </a>           
              </div>
            </div>
          </div>
        </div>
      </section>
		<section className='sectionPadding aboutUs_wrap lightBg'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-5 responsiveSpace'>
              <div className='titleBox'>
                <span>Gallery</span>
                <h2>Fresh and local perfect food for you</h2>
              </div>
              <p>This kitchen is a brewery of life – whether it’s the kids baking parties or their parents elaborate soirees, there’s always something cooking in here.</p>
              <div className='aboutBtn'>
                <a href="#">About us</a>
              </div>
            </div>
            <div className='col-md-5'>
              <div className='aboutImage textCenter responsiveSpace'>
                <div className='middleBox'>
                  <h3>Let’s build something amazing. We’re ready when you are.</h3>
                  <p>We only hire great people who strive to push their ideas into fruition by outmuscling and outhustling the competition.</p>
                  <div className='aboutBtn'>
                    <a href="#">Read more <i class="fa-solid fa-angle-right"></i></a>
                  </div>
                </div>                
              </div>
            </div>
            <div className='col-md-2'>
              <div className='lastImage'>
                <div className='firstBox'>
                  <img src={sideFoodImg1} />
                </div>
                <div className='firstBox'>
                  <img src={sideFoodImg2} />
                </div>
                <div className='firstBox'>
                  <img src={sideFoodImg3} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
		{/* <section className='sectionPadding branchName'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <div className='branchName_inner_wrap textCenter'>
                <h2>Start your experience</h2>
                <h3>Always happy to see you</h3>
                <div className='defultBtn'>
                  <a href="#">Menu</a>
                </div>
              </div>              
            </div>
          </div>
        </div>
      </section> */}
		{/* <section className='sectionPadding post_wrap'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-6'>
              <div className='image_box textCenter overlay responsiveSpace'>
                <div className='contentWrap'>
                  <span>Menus</span>
                  <h2>Book A <br/>Table</h2>
                  <div className='defultBtn'>
                    <a href="#">Reservation</a>
                  </div>
                </div>                
              </div>
            </div>
            <div className='col-md-6'>
              <div className='image_box textCenter overlay'>
                <div className='contentWrap'>
                  <span>Hungry?</span>
                  <h2>Start your <br/>experience today</h2>
                  <div className='defultBtn'>
                    <a href="#">Menus</a>
                  </div>
                </div>                
              </div>
            </div>
          </div>
        </div>        
      </section> */}
    </div>
  )
}
